import { delay } from 'redux-saga';
import { all, call, put, select } from 'redux-saga/effects';
import * as SimplePeer from 'simple-peer';

import {
    bootstrapFinished,
    bootstrapStarted,
    browserCapabilitiesFetched,
    locationSettingsFetched,
    locationSettingsFetching,
    roxanneDataFetchError,
    roxanneDataFetching,
    setLocalSettings,
} from '../actions';
import * as api from '../actions/api';
import { getVisitor } from '../selectors/conversation';
import { getSettings } from '../selectors/settings';
import * as actionTypes from '../typedefs/actionTypes';
import { SettingsState, VisitorState } from '../typedefs/store';
import { init as initLocalStorageManager } from '../util/LocalStorageManager';
import { resumeConversationSaga } from './conversationSaga';
import { startProactiveSaga } from './startSaga';

export function* locationSettingsSaga() {
    let attempts = 0;
    let data = null;
    const settings = yield select(getSettings);

    while (data === null && attempts < 3) {
        try {
            attempts++;
            yield put(locationSettingsFetching(attempts));
            data = yield call(api.fetchSettings, settings.inlineConfig.guid);
            yield put(locationSettingsFetched((data as any).data, settings.inlineConfig));

            return;
        } catch (e) {
            // ignore error and wait to try again
            yield call(delay, 1000);
        }
    }

    yield put({ type: actionTypes.LOCATION_SETTINGS_FETCH_ERROR });
}

export function* roxanneSaga() {
    const roxanneId = getRoxanneId();
    if (!roxanneId) {
        yield put(roxanneDataFetchError('DIDataLayer not available'));
        return;
    }
    yield put(roxanneDataFetching());
    yield put(roxanneDataFetchError('not implemented yet'));
    // todo: fetch roxanne data
}

function getRoxanneId(): number | void {
    if (
        (window as any).DIDataLayer &&
        (window as any).DIDataLayer.user &&
        typeof (window as any).DIDataLayer.user.get === 'function'
    ) {
        const roxanneObj = (window as any).DIDataLayer.user.get();
        if (roxanneObj) return parseInt(roxanneObj.visitor_id, 10);
    }
}

export function* getBrowserCapabilities() {
    let webRtcSupport = false;
    if (SimplePeer.WEBRTC_SUPPORT && (isSecure() || process.env.NODE_ENV === 'development')) {
        webRtcSupport = true;
    }
    yield put(browserCapabilitiesFetched(webRtcSupport));
}

function isSecure() {
    return location.protocol === 'https:';
}

export default function* bootstrapSaga() {
    yield put(bootstrapStarted());

    const { inlineConfig }: SettingsState = yield select(getSettings);

    const LocalStorageManager = initLocalStorageManager(inlineConfig.guid);
    yield put(setLocalSettings(LocalStorageManager.getData()));

    const visitor: VisitorState = yield select(getVisitor);

    yield call(api.setBaseUrl, inlineConfig.apiUrl);
    yield call(api.setSenderId, visitor.senderId);
    yield call(api.initApi, visitor.visitorToken, visitor.channel);

    yield all([call(locationSettingsSaga), call(roxanneSaga), call(getBrowserCapabilities)]);

    if (visitor.hasConvo) yield call(resumeConversationSaga);

    yield put(bootstrapFinished());
    yield call(startProactiveSaga);
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/sagas/bootstrapSaga.ts